import React from "react";
import {
  Stack,
  Typography,
  TextField,
  InputAdornment,
} from "@mui/material";
import "../../../Style/dialogstyle.scss";

export default function ViewRecieve({ editData }) {
  const calculateSubTotal = () => {
    let subTotal = 0;
    if (Array.isArray(editData?.receiveMaterials)) {
      editData?.receiveMaterials?.forEach((item) => {
        subTotal +=
          (parseFloat(item.unitPrice) || 0) * (parseFloat(item.qty) || 0);
      });
    }
    return subTotal.toFixed(2);
  };

  const totalPrice = parseFloat(calculateSubTotal());
  const shippingFee = parseFloat(editData?.shippingFee) || 0;
  const total = totalPrice + shippingFee;

  return (
    <div>
      <Stack
        direction="column"
        spacing={2}
        sx={{ width: "100%" }}
        className="view-dialog-contanier"
      >
        <Stack direction="row" spacing={1} className="view-header">
        <Typography className="field-title-list" sx={{ width: "20%" }}>
            រូបភាព
          </Typography>
          <Typography className="field-title-list" sx={{ width: "20%" }}>
            ឈ្មោះសម្ភារៈ
          </Typography>
          <Typography className="field-title-list" sx={{ width: "20%" }}>
            ឯកតា
          </Typography>
          <Typography className="field-title-list" sx={{ width: "20%" }}>
            តម្លៃ
          </Typography>
          <Typography className="field-title-list" sx={{ width: "20%" }}>
            ចំនួន
          </Typography>
        </Stack>

        {editData?.receiveMaterials?.map((row, index) => (
          <Stack direction="row" spacing={1} key={index}>
          <Stack width="20%" direction="row" justifyContent="flex-start">
            <img
              src={row?.listMaterialUnitId?.imageSrc}
              alt=""
              style={{
                borderRadius: "10px",
                objectFit: "cover",
                width: "50%",
               
              }}
            />
          </Stack>
          <Stack width="20%" direction="column" justifyContent="center">
            <Typography className="field-title" width="100%">
              {row?.listMaterialUnitId?.materialId?.materialKhName}
            </Typography>
          </Stack>

          <Stack width="20%" direction="column" justifyContent="center">
            <Typography className="field-title" width="100%">
              {row?.listMaterialUnitId?.unitId?.unitKhName}
            </Typography>
          </Stack>
          <Stack width="20%" direction="column" justifyContent="center">
            <Typography className="field-title" width="100%">
              {row?.unitPrice}
            </Typography>
          </Stack>
          <Stack width="20%" direction="column" justifyContent="center">
            <Typography className="field-title" width="100%">
              {row?.qty}
            </Typography>
          </Stack>
        </Stack>
        ))}
        <Stack direction="row" spacing={2}>
          <Stack direction="column" spacing={2}>
            <Typography className="field-title-list">ចំណាំ</Typography>
          </Stack>
          <Stack direction="column" spacing={2}>
            <Typography className="field-title-list">:</Typography>
          </Stack>
          <Stack direction="column" spacing={2} width="100%">
            <TextField
              className="text-field"
              fullWidth
              multiline
              rows={2}
              size="small"
              value={editData?.receiveBy?.remark}
            />
          </Stack>
        </Stack>
        <Stack direction="row" justifyContent="flex-end">
          <Stack direction="column" spacing={1} justifyContent="flex-end">
            <Stack direction="row" width="100%">
              <Stack width={"32%"}>
                <Typography className="total-title">តម្លៃ</Typography>
              </Stack>
              <Stack width={"18%"}>
                <Typography className="total-title">:</Typography>
              </Stack>
              <Stack
                direction={"row"}
                width={"50%"}
                justifyContent={"space-between"}
                className="total-boz"
              >
                <Typography className="total-boz-letter">$</Typography>
                <Typography className="total-boz-letter">
                  {totalPrice.toFixed(2)}
                </Typography>
              </Stack>
            </Stack>

            <Stack direction="row" width={"100%"}>
              <Stack justifyContent="center" width={"32%"}>
                <Typography className="total-title">ថ្លៃដឹកជញ្ជូន</Typography>
              </Stack>
              <Stack justifyContent="center" width={"18%"}>
                <Typography>:</Typography>
              </Stack>
              <Stack
                direction={"row"}
                width={"50%"}
                justifyContent={"space-between"}
                className="total-boz"
              >
                <TextField
                  inputProps={{ min: 0 }}
                  className="text-field-right"
                  disabled
                  fullWidth
                  type="number"
                  size="small"
                  value={shippingFee}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">$</InputAdornment>
                    ),
                  }}
                  sx={{
                    "& .css-1ua80n0-MuiInputBase-input-MuiOutlinedInput-input":
                      { textAlign: "right" },
                  }}
                />
              </Stack>
            </Stack>

            <Stack direction="row" width={"100%"}>
              <Stack justifyContent="center" width={"32%"}>
                <Typography className="total-title">តម្លៃសរុប</Typography>
              </Stack>
              <Stack justifyContent="center" width={"18%"}>
                <Typography className="total-title">:</Typography>
              </Stack>
              <Stack
                direction={"row"}
                width={"50%"}
                justifyContent={`space-between`}
                className="total-boz"
              >
                <Typography className="total-boz-letter">$</Typography>
                <Typography className="total-boz-letter">
                  {total.toFixed(2)}
                </Typography>
              </Stack>
            </Stack>
          </Stack>
        </Stack>
      </Stack>
    </div>
  );
}
